import { Link } from "react-router-dom";
import { BOOKING_URL } from "@/data/content";
import { useLang } from "@/i18n";

export default function BookButton({ className = "btn-gold", testid, children, fallback = "/contact?intent=consultation" }) {
  const { t } = useLang();
  const label = children || t("common.book");
  if (BOOKING_URL) {
    return (
      <a data-testid={testid} href={BOOKING_URL} target="_blank" rel="noopener noreferrer" className={className}>
        {label}
      </a>
    );
  }
  if (fallback.startsWith("#")) {
    return (
      <a data-testid={testid} href={fallback} className={className}>
        {label}
      </a>
    );
  }
  return (
    <Link data-testid={testid} to={fallback} className={className}>
      {label}
    </Link>
  );
}
